/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tab-list[_ngcontent-%COMP%]{min-height:100px;border:1px solid var(--input-gray);display:flex;flex-direction:column}.tab-list-item[_ngcontent-%COMP%]{padding:4px 6px;cursor:pointer}.selected-item[_ngcontent-%COMP%], .tab-list-item[_ngcontent-%COMP%]:hover{background-color:var(--bg-highlight-color)}\n/*# sourceMappingURL=interlayer-report-tabs.component.css.map*/"];
export { styles as styles };
